import { ChangeDetectionStrategy, Component } from '@angular/core';
import {PageTitleLayoutComponent} from "../../../components/page-title-layout/page-title-layout.component";
import {SignupButtonComponent} from "../../../components/signup-button/signup-button.component";

@Component({
  selector: 'homey-mathias-ines-article',
  imports: [
    PageTitleLayoutComponent,
    SignupButtonComponent
  ],
  templateUrl: './mathias-ines-article.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MathiasInesArticleComponent {

}
